import {
  Component,
  ElementRef,
  Input,
  NgZone,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';

import { AbstractBaseComponent } from '@ib-shared/abstract/abstract-base';
import * as dayjs from 'dayjs';

@Component({
  selector: 'ib-time-diff',
  templateUrl: './time-diff.component.html',
})
export class TimeDiffComponent
  extends AbstractBaseComponent
  implements OnDestroy, OnChanges
{
  @Input() timestamp: dayjs.Dayjs;
  @Input() intervalSec = 1;

  public expireIn: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private interval: any;

  constructor(private ngZone: NgZone, private elRef: ElementRef) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.timestamp) {
      if (changes.timestamp.currentValue) {
        this.initDiff();
        this.startWatcher();
      } else {
        this.stopWatcher();
      }
    }
  }

  ngOnDestroy(): void {
    this.stopWatcher();
    super.destroySubscriptions();
  }

  private initDiff(): void {
    if (this.elRef.nativeElement) {
      const diff =
        this.timestamp && dayjs.isDayjs(this.timestamp)
          ? this.timestamp.valueOf() - dayjs(new Date()).valueOf()
          : undefined;
      const expireIn = diff ? this.convertMsToTime(diff) : '';
      const el = this.elRef.nativeElement as HTMLElement;
      el.innerText = expireIn;
    }
  }

  private startWatcher(): void {
    this.ngZone.runOutsideAngular(() => {
      this.interval = setInterval(() => {
        this.initDiff();
      }, this.intervalSec * 1000);
    });
  }

  private stopWatcher(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  private convertMsToTime(ms: number): string {
    let sec = Math.floor(ms / 1000);
    let min = Math.floor(sec / 60);
    let hrs = Math.floor(min / 60);
    sec = sec % 60;
    min = min % 60;
    hrs = hrs % 24;
    const result = [
      hrs > 0 ? hrs + 'h' : null,
      min > 0 ? min + 'm' : null,
      sec > 0 ? sec + 's' : null,
    ]
      .filter(i => i)
      .join(' ');
    return result;
  }
}
